<template>
	<div class="content">
		<!-- <div class="breadcrumb">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item><router-link to="/">首页</router-link></el-breadcrumb-item>
				<el-breadcrumb-item>质检名词解释</el-breadcrumb-item>
			</el-breadcrumb>
		</div> -->
		<div class="menu-right">
			<div class="title">
				<span>质检名词解释</span>
			</div>
			<div class="inner" v-for="(item,index) in clauseList" :key="index">
				<div class="sm-title">{{item.title}}</div>
				<p v-for="(item1,index1) in item.list">{{item1.text}}</p>
			</div>
		</div>
	</div>
</template>

<script>
export default{
	data(){
		return {
			clauseList: [
				{
					title: '1. 色斑、亮斑、漏液、错乱：',
					list: [
						{text:'色斑：纯白界面或者其他界面下，屏幕出现其它色彩的斑块；'},
						{text:'亮斑：纯白色界面下，屏幕上亮度异常（发亮或者发暗）的斑块；'},
						{text:'错乱：屏幕显示异常，多表现为出现横竖线；'},
						{text:'漏液：屏幕显示出现黑斑，即无法显示的区域。'}
					]
				},
				{
					title: '2. 亮点、坏点：',
					list: [
						{text:'纯色界面，屏幕出现颜色异常的光点（背光）、亮度异常的光点（亮点）或者无法改变颜色的黑色的点（坏点）。'}
					]
				},
				{
					title: '3. 漏光、色差：',
					list: [
						{text:'漏光：纯色界面时，屏幕四周任何一边明显发亮，或者明显亮暗相间；'},
						{text:'色差：蓝色界面时，仅顶部颜色深浅有差异。'}
					]
				},
				{
					title: '4. 光线感应：',
					list: [
						{text:'手机屏幕亮度能够根据环境亮度自动调节，播打电话时手机靠近耳朵屏幕会自动熄灭离开后会自动亮起。'}
					]
				},
				{
					title: '5. 老化、透图、分层：',
					list: [
						{text:'在蓝色、白色界面下，有深浅不一的条纹（分层），或者屏幕中透出电量、联系人等图标（透图），统称为屏幕老化。'}
					]
				},
				{
					title: '6. 触摸功能不正常：',
					list: [
						{text:'触摸延迟、卡顿或者无反应，均是触摸功能不正常。'}
					]
				},
				{
					title: '7. 黑机（套保机）：',
					list: [
						{text:'IMEI号/序列号在苹果官网查询结果为“已更换产品的序列号”，此类机器不予回收。'}
					]
				},
				{
					title: '8. 水货有锁：',
					list: [
						{text:'国外发行的手机、平板，仅能支持特定运营商的SIM卡。使用国内SIM卡需要使用卡贴，或者对主板进行改造。'}
					]
				},
				{
					title: '9. 丢失模式：',
					list: [
						{text:'开启丢失模式的手机并且卖家不能解除锁定的不予回收。'}
					]
				},
				{
					title: '10. 国行官换机：',
					list: [
						{text:'苹果手机在有效保修期内，由于出现质量问题，苹果官方给予更换的机器。'}
					]
				},
				{
					title: '11. 烧卡机：',
					list: [
						{text:'没有SIM卡槽，不能插入SIM卡，手机号被写入手机中，直接就能拨打电话的手机。'}
					]
				},
				{
					title: '12. iCloud无法注销、账号未注销：',
					list: [
						{text:'出售苹果手机的用户，需要手动将iCloud账号注销，无法注销账号的手机不回收。'},
						{text:'需要注销账号的手机还有：魅族手机的Flyme帐号、小米手机的小米账号、乐视手机的LeCloud、锤子手机的欢喜云服务等。'},
						{text:'如果其他品牌的手机有云服务账号一样需要注销。'}
					]
				},
				{
					title: '13.主板维修：',
					list: [
						{text:'主板防修标签纸破损，主板零件缺失或者有焊接等现象。'}
					]
				},
				{
					title: '14. 机身进水或受潮：',
					list: [
						{text:'防水标签纸变色，螺丝生锈，或主板有水渍。'}
					]
				},
				{
					title: '15. 无线不正常：',
					list: [
						{text:'Wifi不能打开或者连接不上、连接后不稳定。'}
					]
				}
			]
		}
	},
}
</script>

<style scoped>
.breadcrumb{
	width: 1226px;
	padding: 20px 0;
	margin: 0 auto;
}

.menu-right .title span{
	font-size: 24px;
	border-bottom: 3px solid #FF6700;
	padding-bottom: 4px;
}

.menu-right p{
	font-size: 16px;
	line-height: 30px;
	color: #282828;
	margin-top: 20px;
}

.menu-right .inner .sm-title{
	margin-top: 20px;
	color: #FF6800;
}
</style>
